import { Component, OnInit, Input } from '@angular/core';
import { Reminder } from 'app/models/dto/reminder.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reminders-today',
  templateUrl: './reminders-today.component.html',
  styleUrls: ['./reminders-today.component.scss'],
  standalone: false
})
export class RemindersTodayComponent implements OnInit {
  @Input() reminders: Reminder[];

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  viewBorrower(borrowerId: number) {
    this.router.navigate(['/borrower/', borrowerId]);
  }
}
